import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "memeber-profile"
};
var _hoisted_2 = {
  class: "memeber-profile-main"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "list"
};
var _hoisted_5 = {
  class: "memeber-profile-footer"
};
var _hoisted_6 = {
  key: 1,
  class: "edit-h5"
};
var _hoisted_7 = {
  class: "main"
};
var _hoisted_8 = {
  class: "edit-h5-header"
};
var _hoisted_9 = {
  class: "left"
};
var _hoisted_10 = {
  class: "memeber-profile"
};
var _hoisted_11 = {
  class: "memeber-profile-main"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "list"
};
var _hoisted_14 = {
  class: "memeber-profile-footer"
};
import { ref, watch, watchEffect } from '../../../adapter-vue';
import TUIChatEngine, { TUITranslateService, TUIUserService, TUIConversationService, TUIFriendService, TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-profile',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['handleSwitchConversation', 'close', 'openConversation'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var isFriendShip = ref(false);
    var userInfoManager = ref({});
    watchEffect(() => {
      userInfoManager.value = props.userInfo;
    });
    var emits = __emit;
    watch(() => props.userInfo, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (newVal, oldVal) {
        if (newVal === oldVal) return;
        var res = yield TUIUserService.getUserProfile({
          userIDList: [props.userInfo.userID]
        });
        userInfoManager.value = res === null || res === void 0 ? void 0 : res.data[0];
        // 这里需要确认是否是好友关系
        checkFriend();
      });
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      deep: true,
      immediate: true
    });
    var enter = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (ID, type) {
        var name = "".concat(type).concat(ID);
        TUIConversationService.getConversationProfile(name).then(res => {
          TUIConversationService.switchConversation(res.data.conversation.conversationID).then(() => {
            TUIStore.update(StoreName.GRP, 'isShowManageComponent', false);
            if (isUniFrameWork) {
              TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.navigateBack();
            }
          });
        }).catch(err => {
          console.warn('获取会话资料失败', err.code, err.msg);
        });
      });
      return function enter(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    var checkFriend = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* () {
        if (!userInfoManager.value.userID) return;
        TUIFriendService.checkFriend({
          userIDList: [userInfoManager.value.userID],
          type: TUIChatEngine.TYPES.SNS_CHECK_TYPE_BOTH
        }).then(res => {
          var _res$data;
          var relation = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.successUserIDList) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.relation;
          isFriendShip.value = relation === TUIChatEngine.TYPES.SNS_TYPE_BOTH_WAY;
        });
      });
      return function checkFriend() {
        return _ref4.apply(this, arguments);
      };
    }();
    var showEnter = () => {
      return isFriendShip.value || !TUIStore.getData(StoreName.APP, 'isOfficial');
    };
    var close = tabName => {
      emits('close', tabName);
    };
    return (_ctx, _cache) => {
      return !_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        class: "avatar",
        src: _unref(userInfoManager).avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
        onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
      }, null, 8, _hoisted_3), _createElementVNode("ul", _hoisted_4, [_createElementVNode("h2", null, _toDisplayString(_unref(userInfoManager).nick || _unref(userInfoManager).userID), 1), _createElementVNode("li", null, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "ID：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).userID), 1)]), _createElementVNode("li", null, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.个性签名")) + "：", 1), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).selfSignature), 1)])])]), _createElementVNode("div", _hoisted_5, [showEnter() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "button",
        onClick: _cache[0] || (_cache[0] = $event => enter(_unref(userInfoManager).userID, 'C2C'))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.发送消息")), 1)) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("main", _hoisted_7, [_createElementVNode("header", _hoisted_8, [_createElementVNode("aside", _hoisted_9, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u6210\u5458")), 1)]), _createElementVNode("span", {
        class: "close",
        onClick: _cache[1] || (_cache[1] = $event => close('profile'))
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        class: "avatar",
        src: _unref(userInfoManager).avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
        onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
      }, null, 8, _hoisted_12), _createElementVNode("ul", _hoisted_13, [_createElementVNode("h1", null, _toDisplayString(_unref(userInfoManager).nick || _unref(userInfoManager).userID), 1), _createElementVNode("li", null, [_cache[4] || (_cache[4] = _createElementVNode("label", null, "ID：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).userID), 1)]), _createElementVNode("li", null, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.个性签名")) + "：", 1), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).selfSignature), 1)])])]), _createElementVNode("div", _hoisted_14, [showEnter() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "button",
        onClick: _cache[2] || (_cache[2] = $event => enter(_unref(userInfoManager).userID, 'C2C'))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.发送消息")), 1)) : _createCommentVNode("", true)])])])]));
    };
  }
});